<template>
  <div class="list">
    <div class="userSetting">
      <h1 class="topTitle">ユーザー管理</h1>
      <div class="container">
        <div class="outer-menu">
          <input class="checkbox-toggle" v-model="isShowSerchBox" type="checkbox" />
          <div class="hamburger" :class="{ searchIcon: !isShowSerchBox }" @click="isShowSerchBox = !isShowSerchBox">
            <div v-if="isShowSerchBox"></div>
          </div>
          <div class="menu">
            <div class="searchArea">
              <div class="searchBox">
                <h2 class="itemTitle">検索</h2>
                <ul>
                  <li>
                    <label for="name">ユーザー名:</label>
                    <input type="text" placeholder="ユーザー名" id="name" v-model="serchItem.name" tabindex="1" />
                  </li>
                </ul>
                <div class="btnBox">
                  <button class="btn" @click="(isShowSerchBox = !isShowSerchBox), clear()">
                    クリア
                  </button>
                  <button class="btn" @click="(isShowSerchBox = !isShowSerchBox), serch()">
                    検索
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <h3 class="gray">
          ログイン設定拡張機能Downloadは<a
            class="a"
            href="https://xs936289.xsrv.jp/TEST_TOOL/Extentions/SellersLoginSetting.zip"
            >こちら</a
          >
        </h3> -->
        <br />

        <div class="roomBox">
          <h5>チャットワーク通知設定</h5>
          <div class="validErrMsg" v-for="err in $v.roomId.errMsg" :key="err">
            {{ err }}
          </div>
          <div class="fm">

            <input type="text" class="input-2 min" placeholder="ルームID" v-model="roomId"
              @input="valid($v.roomId, 'ルームID', 'HankakuSuuzi')" />
            <button class="btn minBtn" @click="setRoomId">設定</button>
          </div>
        </div>

        <div class="item-wrap">
          <!-- <div class="loginInf">
                    <h2 class="tit">ログイン設定</h2>
                    <input type="file" @change="setZip">
                    <button class="btn" @click="zipPost">送信</button>
                </div><br> -->
          <table class="itemTable">
            <tr>
              <th class="listTitle">変更</th>
              <th class="listTitle">ユーザー名</th>
              <!-- <th class="listTitle">
                            1日最大出品数
                        </th> -->
              <!-- <th class="listTitle">出品時間</th>
              <th class="listTitle">値引時間</th> -->
              <th class="listTitle">出品・値引き間隔</th>
              <!-- <th class="listTitle">ログイン設定ファイル</th>
              <th class="listTitle">ログイン確認</th>
              <th class="listTitle">プロキシIP</th>
              <th class="listTitle">プロキシポート番号</th> -->

            </tr>
            <tr v-for="(item, index) in getItems" :key="item.ITEM_ID" v-show="item.display">
              <td class="listItem">
                <div class="remBox">
                  <span class="remText">この行のユーザーが<br />削除されます</span>
                  <button class="btn remove" @click="remove(item)">
                    削除
                  </button>
                </div>
                <div class="updBox">
                  <span class="updText">この行のユーザーを<br />左の内容に更新します</span><button class="btn upd"
                    @click="change(item)">更新</button>
                </div>
                <div class="remBox">
                  <span class="remText">この行のユーザーの<br />トークンを設定します</span>
                  <button class="btn upd" @click="open_set_token(item)">
                    トークン設定
                  </button>
                </div>
              </td>
              <td class="listItem center imgF">
                <input type="text" v-model="item.USER_NAME" style="min-width: 100px; margin: 5px" />
              </td>

              <td class="listItem">
                <div class="validErrMsg" v-for="err in $v.tmpUserList.$each[
                  index + (currentPage - 1) * perPage
                ].PAUSE_TIME.errMsg" :key="err">
                  {{ err }}
                </div>
                
                <p class="unit">メルカリ　　</p>
                <input type="text" v-model="item.PAUSE_TIME" @input="
                  valid(
                    $v.tmpUserList.$each[index + (currentPage - 1) * perPage]
                      .PAUSE_TIME,
                    '出品間隔'
                  )
                  " />
                <p class="unit">分</p>

                <!-- PayPay 出品間隔 -->
                <p class="unit">PayPay　　　</p>
                <input type="text" v-model="item.PAUSE_TIME_paypay" @input="
                  valid(
                    $v.tmpUserList.$each[index + (currentPage - 1) * perPage]
                      .PAUSE_TIME_paypay,
                    'paypay出品間隔'
                  )
                  " />
                <p class="unit">分</p>

                <p class="unit">ラクマ　　　</p>
                <input type="text" v-model="item.PAUSE_TIME_rakuma" @input="
                  valid(
                    $v.tmpUserList.$each[index + (currentPage - 1) * perPage]
                      .PAUSE_TIME_rakuma,
                    'ラクマ出品間隔'
                  )
                  " />
                <p class="unit">分</p>
              </td>
            </tr>
            <div class="none">
              <input type="text" v-model="tmpLogin" />
            </div>
          </table>
          <button class="btn" @click="isModal = !isModal" :disabled="userInfo.CHILD_NUM <= userList.length">
            新規ユーザー追加
          </button>
        </div>
        <div class="pdgTop10">
          <vuejs-paginate :page-count="getPaginateCount" :prev-text="'<'" :next-text="'>'"
            :click-handler="paginateClickCallback" :container-class="'pagination justify-content-center'"
            :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'"
            :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"
            :first-last-button="true" :first-button-text="'<<'" :last-button-text="'>>'"></vuejs-paginate>
        </div>
        <div class="overlay" v-show="set_token_field">
          <div class="createModal">
            <div class="swal2-popup swal2-modal swal2-show" style="display: grid;">
              <div class="createUser">
                <div class="login_form_top">
                  <h1 class="title">メルカリログイン設定</h1>
                </div>
                <div class="formBox">
                  <h2 id="userName" class="itemLabel">ユーザー<span>{{ tokenObj.USER_NAME }}</span></h2>

                  <div>
                    <input type="radio" v-model="tokenObj.TYPE" id='type' value="0">
                    <label class="radioLabel" for='type'>アプリ版トークン設定</label>
                    <input type="radio" v-model="tokenObj.TYPE" id='type2' value="1">
                    <label class="radioLabel" for='type2'>WEB版トークン設定</label>
                  </div>
                  <!-- <div
                          class="validErrMsg"
                          v-for="err in $v.tokenObj.SELLER_ID.errMsg"
                          :key="err"
                        >
                          {{ err }}
                        </div>
                        <h2 id="SELLER_ID" class="itemLabel">セラーID</h2>
                        <input type="text" v-model="tokenObj.SELLER_ID" @input="valid($v.tokenObj.SELLER_ID, 'セラーID', 'Mozi9')"> -->
                  <div class="validErrMsg" v-for="err in $v.tokenObj.AUTH_TOKEN.errMsg" :key="err">
                    {{ err }}
                  </div>
                  <h2 id="AUTH_TOKEN" class="itemLabel">アクセストークン</h2>
                  <input type="text" v-model="tokenObj.AUTH_TOKEN">
                  <div v-if="tokenObj.TYPE == '0'">
                    <h2 id="REF_TOKEN" class="itemLabel">リフレッシュトークン</h2>
                    <input type="text" v-model="tokenObj.REF_TOKEN">
                    <h2 id="UUID" class="itemLabel">uuid</h2>
                    <input type="text" v-model="tokenObj.UUID">
                    <h2 id="EXPIRATION_DATE" class="itemLabel">expiration_date</h2>
                    <input type="text" v-model="tokenObj.EXPIRATION_DATE">
                  </div>
                  <input type="hidden" v-model="tmp">
                  <div class="btnBox">
                    <button class="btn repage" @click="set_token_field = !set_token_field">キャンセル</button>
                    <button class="btn" @click="loginSet">更新</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="overlay" v-show="isModal">
          <div class="createModal">
            <div class="swal2-popup swal2-modal swal2-show" style="display: grid">
              <div class="login">
                <div class="login_form_top">
                  <h1 class="title">ユーザー作成</h1>
                </div>
                <div class="formBox">
                  <h2 id="userName" class="itemLabel">名前</h2>
                  <div class="validErrMsg" v-for="err in $v.postItem.USER_NAME.errMsg" :key="err">
                    {{ err }}
                  </div>
                  <input type="text" v-model="postItem.USER_NAME" @input="valid($v.postItem.USER_NAME, 'ユーザー名')" />


                  <div class="none">
                    <input type="text" v-model="tmpLogin" />
                  </div>
                  <div class="btnBox">
                    <button class="btn repage" @click="isModal = !isModal">
                      キャンセル
                    </button>
                    <button class="btn" @click="create">作成</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btnBox subArea">
          <button class="btn repage" @click="returnPage">戻る</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { userRepository } from "@/Repositories/userRepository.js";
import { mLoginRepository } from '@/Repositories/mLoginRepository.js'
import VueJsPaginate from "vuejs-paginate";
import check from "@/common/commonCheck";
import {
  required,
  minLength,
  maxLength,
  maxValue,
  minValue
} from "vuelidate/lib/validators";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

import axios from "axios";
export default {
  data() {
    return {
      alertFlg: true,
      isShowSerchBox: false,
      set_token_field: false,
      tokenObj: {},
      userInfo: {},
      userList: [],
      tmpUserList: [],
      tmpLogin: "",
      tmp: "",
      tmpZip: null,
      serchItem: {
        name: null,
      },
      roomId: '',
      isModal: false,
      postItem: {
        USER_ID: "",
        USER_NAME: "",
        PASSWORD: "",
        DEL_FLG: 0,
        PAUSE_FLG: 0,
        ROLE: 2,
        MAX_SELE_NUM: 0,
        SALE_TIME: 0,
        DOWN_TIME: 0,
        PAUSE_TIME: 300,
        PAUSE_TIME_paypay: 300, // PayPay用の出品間隔
        PAUSE_TIME_rakuma: 300, // ラクマ用の出品間隔
        PROXY_IP: "",
        PROXY_PORT: "",
        PARENT_FLG: 1,
        CHILD_NUM: 0,
      },
      currentPage: 1,
      perPage: 20,
    };
  },
  components: {
    "vuejs-paginate": VueJsPaginate,
    "vue-timepicker": VueTimepicker,
  },
  methods: {
    setZip(e) {
      var fileName = e.target.files[0].name;
      var regex = /.ckz$/g;
      var found = fileName.match(regex);
      var userId = e.target.id;
      if (found == null) {
        this.$swal(".ckzを選択してください", "", "error");
      } else {
        this.tmpZip = e.target.files[0];
        this.zipPost(userId);
      }
    },
    zipPost(userId) {
      const data = new FormData();
      data.append("ZIP", this.tmpZip);
      data.append("USER_ID", userId);
      data.append("IS_UPZIP", 0);
      axios
        .post("/api/v1/LoginInfo.php", data, {
          headers: { "content-type": "multipart/form-data" },
        })
        .then((res) => {
          this.$swal("送信しました", "", "success");
        })
        .catch((error) => {
          this.$swal("失敗しました", "", "error");
        });
    },
    serch() {
      let vm = this;
      if (vm.serchItem.name) {
        //名前フィルター
        vm.tmpUserList.filter((item, i, arr) => {
          arr[i].display = item.USER_NAME.match(vm.serchItem.name) != null;
        });
      }
    },
    clear() {
      for (var i = 0; i < this.tmpUserList.length; i++) {
        this.tmpUserList[i].display = true;
      }
      this.serchItem = {};
    },
    paginateClickCallback(pageNum) {
      this.currentPage = Number(pageNum);
    },
    remove(item, index) {
      let vm = this;

      vm.$functions
        .swAlert(
          vm,
          "warning",
          "このユーザーを削除してよろしいですか？",
          `ユーザー名:${item.USER_NAME}`
        )
        .then((btn) => {
          if (btn.isConfirmed) {
            var postItem = { ...item };
            postItem.DEL_FLG = 1;
            delete postItem.siteType;
            delete postItem.display;
            userRepository.methods.change(postItem).then((res) => {
              vm.userList.splice(index - 1, 1);
              this.$swal("削除しました", {
                icon: "success",
              }).then((res) => {
                vm.postItem.USER_NAME = "新規追加ユーザー";
                vm.postItem.PROXY_IP = item.PROXY_IP;
                vm.postItem.PROXY_PORT = item.PROXY_PORT;
                vm.alertFlg = false;
                vm.create();
                // vm.$functions.reload(vm)
              });
            });
          }
        });
    },
    change(item) {
      let vm = this;
      // var item = vm.tmpUserList[index];
      // if (!vm.chgUserValidAll(vm.$v.tmpUserList.$each[index])) return;
      vm.$functions
        .swAlert(
          vm,
          "warning",
          "このユーザーを更新してよろしいですか？",
          `ユーザー名:${item.USER_NAME}`
        )
        .then((btn) => {
          if (btn.isConfirmed) {
            var postItem = { ...item };
            postItem.PAUSE_TIME = postItem.PAUSE_TIME * 60;
            postItem.PAUSE_TIME_paypay = postItem.PAUSE_TIME_paypay * 60; // PayPayの値も送信
            postItem.PAUSE_TIME_rakuma = postItem.PAUSE_TIME_rakuma * 60; // ラクマの値も送信
            delete postItem.siteType;
            delete postItem.display;
            userRepository.methods.change(postItem).then((res) => {
              this.$swal("更新しました", {
                icon: "success",
              }).then((res) => {
                vm.$functions.reload(vm);
              });
            });
          }
        });
    },
    create() {
      let vm = this;
      if (!vm.crtUserValidAll()) return;
      vm.isModal = false;
      userRepository.methods.Create(vm.postItem).then((res) => {
        if (vm.alertFlg) {
          vm.$swal("ユーザーを作成しました", "", "success").then((res) => {
            vm.$functions.reload(vm);
          });
        } else {
          vm.$functions.reload(vm);
        }
      });
    },
    returnPage() {
      let vm = this;
      vm.$router.back();
    },
    init() {
      let vm = this;
      var tmpuser = vm.$functions.getSStorage("userInfo");
      userRepository.methods.GetMe().then(res => {
        vm.userInfo = res.data;
      })
      vm.roomId = vm.userInfo.ROOM_ID;
      userRepository.methods
        .getChild()
        .then((res) => {
          var data = res.data;
          for (var i = 0; i < data.length; i++) {
            if (data[i].siteType) data[i].siteType = data[i].siteType.split("");
            data[i].PAUSE_TIME = data[i].PAUSE_TIME / 60
            // PAUSE_TIME_paypayを分単位に変換
            if (data[i].PAUSE_TIME_paypay) {
              data[i].PAUSE_TIME_paypay = data[i].PAUSE_TIME_paypay / 60;
            }

            // PAUSE_TIME_rakumaを分単位に変換
            if (data[i].PAUSE_TIME_rakuma) {
              data[i].PAUSE_TIME_rakuma = data[i].PAUSE_TIME_rakuma / 60;
            }
            // data[i].DOWN_TIME = ("00" + data[i].DOWN_TIME).slice(-2);
            data[i].display = true;
          }
          vm.userList = data;
          vm.tmpUserList = data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    valid(v, name, regexType) {
      check.checkStr(v, name, regexType);
    },
    chgUserValidAll(item) {
      let vm = this;
      try {
        if (!check.checkStr(item.MAX_SELE_NUM, "1日最大出品数"))
          throw "userName";
        if (!check.checkStr(item.PAUSE_TIME, "出品間隔")) throw "userId";
      } catch (e) {
        vm.tmp = "tmp";
        return false;
      }
      return true;
    },
    /**
     * 全てのバリデーションチェックを実行し、エラーメッセージを設定します
     */
    crtUserValidAll() {
      let vm = this;
      try {
        if (!check.checkStr(vm.$v.postItem.USER_NAME, "ユーザー名"))
          throw "userName";
        // if(!check.checkStr(vm.$v.postItem.USER_ID, 'ユーザーID')) throw 'userId';

        // if(!check.checkStr(vm.$v.postItem.PASSWORD, 'パスワード')) throw 'password';
        // if (!check.checkStr(vm.$v.postItem.PROXY_IP, "プロキシIPアドレス"))
        //   throw "porxyIp";
        // if (!check.checkStr(vm.$v.postItem.PROXY_PORT, "プロキシポート番号"))
        //   throw "porxyPort";
      } catch (e) {
        vm.$scrollTo(`#${e}`, { duration: 1000 });
        vm.tmpLogin = "tmp";
        return false;
      }
      return true;
    },
    setRoomId() {
      let vm = this;
      userRepository.methods.setRoomId(vm.roomId)
        .then(res => {
          vm.$swal("ルームIDを設定しました。", "", "success")
          vm.userInfo.ROOM_ID = vm.roomId;
          console.log(vm.userInfo);
          vm.$functions.setSStorage('userInfo', vm.userInfo);
          vm.userInfo = vm.$functions.getSStorage("userInfo");
        }).catch(err => {
          vm.$swal("設定に失敗しました。", "", "error")
        })
    },
    open_set_token(item) {
      let vm = this;
      vm.tokenObj = {};

      vm.tokenObj.USER_ID = item.USER_ID;
      vm.getLoginInfo(item);
      vm.set_token_field = true;
      console.log(vm.set_token_field);
    },
    getLoginInfo(item) {
      let vm = this;
      var id = vm.tokenObj.USER_ID;
      mLoginRepository.methods.Set({
        TYPE: 'serch',
        USER_ID: id
      }).then(res => {
        if (res.data.length > 0) {
          vm.tokenObj = res.data[0];
          vm.tokenObj.USER_NAME = item.USER_NAME;
        }
        var type = vm.tokenObj.EXPIRATION_DATE == '2100000000' ? '1' : '0';
        vm.$set(vm.tokenObj, 'TYPE', type);
      })
    },
    loginSet() {
      let vm = this;
      // console.log(check.checkStr(vm.$v.tokenObj.SELLER_ID, 'セラーID', 'Mozi9'));
      // if (!check.checkStr(vm.$v.tokenObj.SELLER_ID, 'セラーID', 'Mozi9')) return;

      if (vm.tokenObj.TYPE == "1") {
        vm.tokenObj.REF_TOKEN = '0';
        vm.tokenObj.UUID = '0';
        vm.tokenObj.EXPIRATION_DATE = '2100000000';
      }
      mLoginRepository.methods.Set(vm.tokenObj).then(res => {
        this.$swal("メルカリログイン設定をしました", {
          icon: "success",
        }).then(res => { vm.$functions.reload(vm) });
      })
    },
  },
  computed: {
    getPaginateCount: function () {
      return Math.ceil(this.tmpUserList.length / this.perPage);
    },
    getItems() {
      if (this.userList.length == 0) return;
      let start = (this.currentPage - 1) * this.perPage;
      let end = this.currentPage * this.perPage;
      return this.tmpUserList.slice(start, end);
    },
  },
  created: function () {
    let vm = this;
    vm.init();
  },

  validations: {
    roomId: {
      minLength: minLength(9),
      maxLength: maxLength(9)
    },
    //新規ユーザ作成
    postItem: {
      //   USER_ID:{
      //       required,
      //       maxLength:maxLength(8),
      //       err:(val)=> check.HankakuEisuu(val)
      //   },
      USER_NAME: {
        required,
      },
      //   PASSWORD:{
      //       required
      //   },
      // PROXY_IP: {
      //   required,
      //   maxLength: maxLength(60),
      // },
      // PROXY_PORT: {
      //   required,
      //   maxLength: maxLength(60),
      // },
    },
    tokenObj: {
      AUTH_TOKEN: {
        required,
      },
    },
    //テーブル編集
    tmpUserList: {
      $each: {
        MAX_SELE_NUM: {
          required,
          maxValue: maxValue(60),
        },
        PAUSE_TIME: {
          required,
          // minValue: minValue(300),
        },
        PAUSE_TIME_paypay: {
          required,
          // minValue: minValue(300),
        },
        PAUSE_TIME_rakuma: {
          required,
          // minValue: minValue(300),
        },
        PROXY_IP: {
          required,
          maxLength: maxLength(60),
        },
        PROXY_PORT: {
          required,
          maxLength: maxLength(60),
        },
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import "../style/menu.scss";
@import "../style/list.scss";
@import "../style/userSetting.scss";
@import "../style/login.scss";
</style>